import startAnalytics from '@fiverr-private/gtm';

window.addEventListener('load', () => {
    startAnalytics();
}, { once: true });
